initGettersAndSetters();

//init AOS
if (is.not.ie()) {
    AOS.init();
} else {
    $('*').removeAttr("data-aos");
}

if ($('.l-asideHero').length) {
    $(window).on('load resize', function() {
        var props_rdf = {
            viewport_w: $(document).width(),
            container_w: $('.l-mainWithSidebar .u-container').innerWidth(),
            padding: 15,
            sidebar_w: 370,
            el_asideHero: $('.l-asideHero')
        };
        var calcWidth = (props_rdf.viewport_w - props_rdf.container_w) / 2;
        calcWidth = calcWidth + props_rdf.sidebar_w - props_rdf.padding;
        props_rdf.el_asideHero.width(calcWidth);
    });

    $(window).on('scroll', function () {stickyPosition('.c-aside__fixed', 10, get__navHeight() + 10);});
    $(window).on('load', function () {stickyPosition('.c-aside__fixed', 10, get__navHeight() + 10);});
}

if ($('.js-scrollLink').length) {
    $('.js-scrollLink').on('click', function(e) {
        e.preventDefault();
        var finalDestiny = $(this).attr('href');
        goToSection__scroll(finalDestiny, 100, 0, 700, 10);
    });
}

if ($('.l-rdf_nav').length) {
    // vars
    var nav_scrollInit = 0;
    var nav_classActive = 'is-active';
    var nav_el = {
        body: $('body'),
        hamburguer: $('.c-hamburguer'),
        mask: $('.l-rdf_nav__maskMenu'),
        nav: $('.l-rdf_nav'),
        navContentHero: $('.l-rdf_nav__contentHero'),
        liWithoutSubMenu: $('.l-rdf_nav__menu li a'),
    };

    // functions
    function rdf_nav__showMask() {
        nav_el.mask.addClass(nav_classActive);
    }
    function rdf_nav__hideMask() {
        nav_el.mask.removeClass(nav_classActive);
    }
    function rdf_nav__overflowBlocked() {
        nav_el.body.addClass('u-overflowBlocked');
    }
    function rdf_nav__overflowFree() {
        nav_el.body.removeClass('u-overflowBlocked');
    }
    function rdf_nav__closeNavContent() {
        nav_el.navContentHero.removeClass(nav_classActive);
    }
    function rdf_nav__openNavContent() {
        nav_el.navContentHero.addClass(nav_classActive);
    }
    function rdf_nav__inactiveHamburguer() {
        nav_el.hamburguer.removeClass(nav_classActive);
    }
    function rdf_nav__activeHamburguer() {
        nav_el.hamburguer.addClass(nav_classActive);
    }

    function rdf_nav__closeAllMenuItens() {
        rdf_nav__hideMask();
        rdf_nav__overflowFree();
        rdf_nav__closeNavContent();
        rdf_nav__inactiveHamburguer();
    }
    function rdf_nav__openAllMenuItens() {
        rdf_nav__showMask();
        rdf_nav__overflowBlocked();
        rdf_nav__openNavContent();
        rdf_nav__activeHamburguer()
    }

    // effect on scroll
    $(window).on('scroll', function(event) {
        var scrollBody = $(this).scrollTop();

        // scroll up to 99
        if (scrollBody > 99) {
            nav_el.nav.addClass('scrolled');
        } else {
            nav_el.nav.removeClass('scrolled');
        }

        // middle class
        if (scrollBody > 260) {
            nav_el.nav.addClass('hidden');
            nav_el.nav.addClass('scrolledMiddle');
        } else {
            nav_el.nav.removeClass('hidden');
            nav_el.nav.removeClass('scrolledMiddle');
        }

        // scroll up or down
        if (scrollBody < nav_scrollInit) {
            nav_el.nav.removeClass('hidden');
            nav_el.nav.addClass('scrolledUp');
            nav_el.nav.removeClass('scrolledDown');
        } else {
            nav_el.nav.removeClass('scrolledUp');
            nav_el.nav.addClass('scrolledDown');
        }

        // close menus on hidden nav
        if(nav_el.nav.hasClass('hidden')) {
            rdf_nav__closeAllMenuItens();
        }

        // reference var
        nav_scrollInit = scrollBody;
    });
    $(window).on('load', function(event) {
        var scrollBody = $(this).scrollTop();
        if (scrollBody > 1) {
            nav_el.nav.addClass('scrolled');
        } else {
            nav_el.nav.removeClass('scrolled');
        }
    });

    // open/close/menus/submenus/hamburguer on clicks
    nav_el.hamburguer.on('click', function() {
        if ($(this).hasClass(nav_classActive)) {
            rdf_nav__closeAllMenuItens();
        } else {
            rdf_nav__openAllMenuItens();
        }
    });
    nav_el.mask.on('click', function() {
        rdf_nav__closeAllMenuItens()
    });
    nav_el.liWithoutSubMenu.on('click', function() {
        rdf_nav__closeAllMenuItens();
    });
}

if ($('.liSelect').length) {
    $('.liSelect select').on('focusin', function () {
        $(this).parent('.liSelect').addClass('is-active');
    });
    $('.liSelect select').on('focusout', function () {
        $(this).parent('.liSelect').removeClass('is-active');
    });
}

$('.c-cardDownload').on('click', function() {
    var titleFile = $(this).children('p').html();
    var codigo = $(this).attr('data-nota');
    console.log(titleFile);
    $('.c-downloadHero').children('p').children('span').html(titleFile);
    $('#formDownload__codigo').val(codigo);
});

$("input.telMask")
    .mask("(99) 9999-9999?9")
    .focusout(function (event) {
        var target, phone, element;
        target = (event.currentTarget) ? event.currentTarget : event.srcElement;
        phone = target.value.replace(/\D/g, '');
        element = $(target);
        element.unmask();
        if(phone.length > 10) {
            element.mask("(99) 99999-999?9");
        } else {
            element.mask("(99) 9999-9999?9");
        }
    });

function validField(field){
    if(field.val() === '' || field.val() === undefined || field.val() === null){
        field.addClass('error');
        return false;
    }else{
        if(field.hasClass('email')){
            var filtro = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            if(filtro.test(field.val())){
                field.removeClass('error');
                //console.log('Email ' + field.val() + ' valido!');
                return true;
            } else {
                //console.log('Email ' + field.val() + ' invalido!');
                field.addClass('error');
                return false;
            }
        }else{
            field.removeClass('error');
            return true;
        }
    }
}
$(function () {
    $(document).on('change','#formAside__estado',function(e) {
        e.preventDefault();
        var uf = $(this).val();
        if ($(this).val() != '') {
            $.ajax({
                type: "POST",
                url: "ajax-cidades.php",
                data: 'uf=' + uf,
                success: function(result) {
                    $('#formAside__cidade').html(result);
                }
            });
        } else {
            $('#formAside__cidade').html('<option value="" disabled selected>Cidade</option>');
        }
    });

    $(document).on('blur','.field',function() {
        validField($(this));
    });

    $(document).on('click','#btnEnviar',function(e) {
        var go = true;
        $('#formRDFund .field').each(function(){
            if(validField($(this)) && go){
                go = true;
            }else{
                go = false;
            }
        });
        if(go){
            $('#btnEnviar').attr('disabled', true);
            Swal.fire({
                title: 'Enviando mensagem, aguarde...',
                showConfirmButton: false,
                onBeforeOpen: function() {
                    Swal.showLoading();
                }
            });
            $.ajax({
                type: "POST",
                url: "envia-landing",
                data: $('#formRDFund').serialize(),
                success: function(result) {
                    result = result.split('|');
                    if(parseInt(result[1]) === 1){
                        Swal.fire({
                            type: 'success',
                            title: 'Mensagem enviada com sucesso!',
                            showConfirmButton: false,
                            timer: 2000,
                            onClose: function() {
                                setTimeout(function(){
                                    $('#btnEnviar').attr('disabled', false).html('Enviar');
                                    $("#formRDFund .field").val('');
                                    $("#formRDFund .field").removeClass('error');
                                    $('#formAside__cidade').html('<option value="" disabled selected>Cidade</option>');
                                },500);
                            }
                        });
                    }else{
                        Swal.fire({
                            type: 'error',
                            title: 'Atenção!',
                            text: result,
                            showConfirmButton: false,
                            timer: 3000,
                            onClose: function() {
                                setTimeout(function(){
                                    $('#btnEnviar').attr('disabled', false).html('Enviar');
                                },500);
                            }
                        });
                    }
                }
            })
        }
    });

    $(document).on('click','#btnDownload',function(e) {
        var go = true;
        $('#formNotaTecnica .field').each(function(){
            if(validField($(this)) && go){
                go = true;
            }else{
                go = false;
            }
        });
        if(go){
            $('#btnDownload').attr('disabled', true).html('Enviando...');
            $.ajax({
                type: "POST",
                url: "envia-nota-tecnica",
                data: $('#formNotaTecnica').serialize(),
                success: function(result) {
                    result = result.split('|');
                    if(parseInt(result[1]) === 1){
                        Swal.fire({
                            type: 'success',
                            title: 'Solicitação enviada!',
                            html: result[2],
                            confirmButtonColor:'#414550',
                            onClose: function() {
                                setTimeout(function(){
                                    $('#btnDownload').attr('disabled', false).html('Solicitar');
                                    $('#formNotaTecnica .field').val('').removeClass('error');
                                    $.fancybox.close();
                                },500);
                            }
                        });
                    }else{
                        Swal.fire({
                            type: 'error',
                            title: 'Atenção!',
                            text: result[2],
                            showConfirmButton: false,
                            timer: 3000,
                            onClose: function() {
                                setTimeout(function(){
                                    $('#btnDownload').attr('disabled', false).html('Solicitar');
                                },500);
                            }
                        });
                    }
                }
            })
        }
    });
});

$("#formNews").validate({
    submitHandler: function (form) {
        $(form).ajaxSubmit({
            //target: 'status-envio',
            beforeSubmit: function () {
                Swal.fire({
                    title: 'Enviando, aguarde...',
                    showConfirmButton: false,
                    onBeforeOpen: function() {
                        Swal.showLoading()
                    }
                });
                $('#btnNews').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                if(parseInt(result[0].charAt(result[0].length-1)) == 1){
                    Swal.fire({
                        type: 'success',
                        title: 'Enviado com sucesso!',
                        showConfirmButton: false,
                        timer: 2000,
                        onClose: function() {
                            setTimeout(function(){
                                $('#btnNews').attr('disabled',false);
                                $("#formNews .field").val('');
                                $("#formNews .field").removeClass('error');
                            },500)
                        }
                    });
                }else{
                    Swal.fire({
                        type: 'error',
                        title: 'Atenção!',
                        text: result,
                        showConfirmButton: false,
                        timer: 3000,
                        onClose: function() {
                            setTimeout(function(){
                                $('#btnNews').attr('disabled', false);
                            },500)
                        }
                    });
                }
            }
        });
    }
});
$(document).on('focus', '.field-hp', function() {
    $('.help-block').show();
})

///whatsapp
if ($('.m_whatsApp').length) {
    var wpp__parts = {
        link_mobile: 'http://api.whatsapp.com/',
        link_web: 'https://web.whatsapp.com/',
        phone: 'send?phone=',
        msg: 'text='
    };
    $('.js-openWhatsModule').on('click', function() {
        var wppNumber = $(this).parent('.m_whatsApp').attr("data-whatsNumber");
        openWhatsApp(wppNumber);
    });
    $('.js-openWhatsModule__nav').on('click', function() {
        var wppNumber = $('.m_whatsApp').attr("data-whatsNumber");
        openWhatsApp(wppNumber);
    });
    function openWhatsApp(number) {
        if (is.iphone() || is.androidPhone() || is.windowsPhone() || is.blackberry() || is.mobile()) {
            window.open(wpp__parts.link_mobile + wpp__parts.phone + number, '_blank');
        } else {
            window.open(wpp__parts.link_web + wpp__parts.phone + number, '_blank');
        }
    }
}